import React from 'react';

import {ColorCircle} from '@optimaxdev/design-system';
import {Icon, Plus} from '@optimaxdev/icons';

import {ColorType} from 'types/types';

import {AccessoryType} from '../../store/reducers/accessories/accessoriesType';

import s from './colorBoxWithPlusIcon.scss';

type PropsType = {
    /**
     * Selected simple accessory id
     */
    id: string;

    /**
     * Colors
     */
    colors: AccessoryType['color'][];

    /**
     * On color change callback
     */
    changeSimple: (color: ColorType) => void;

    /**
     * Colors to see at a time
     */
    colorsLimit?: number;

    /**
     * Callback for click on plus icon
     */
    onPlusClickHandler?: () => void;
};

/**
 * Component for render color box
 * @param {PropsType} props - component's properties
 * @return {Node} - rendered component
 */
export const ColorBoxWithPlusIcon = ({
    changeSimple,
    colors,
    colorsLimit = 4,
    id,
    onPlusClickHandler,
}: PropsType) => {
    if (colors.length < 2) return null;

    const elements = colors.slice(0, colorsLimit).map((color, index) => {
        if (!color) return null;

        return (
            <ColorCircle
                tooltipSettings={{
                    children: '',
                    closeTrigger: 'hover',
                    content: <div className={s.tooltipNew}>{color.color_name}</div>,
                    offset: index === 0 ? -8 : 0,
                    openTrigger: 'hover',
                    position: index === 0 ? 'top-start' : 'top',
                    size: 'small',
                    tooltipAnimation: 'fastMoving',
                    windowBorderPadding: 10,
                }}
                active={id === color.id}
                ariaLabel={`Choose Color ${color.color_name}`}
                changeSimple={() => changeSimple(color)}
                circleSettings={{...color, colorName: color.color_name}}
                key={`${color.id}_${color.color_name}`}
                size="small"
                hasTooltip
            />
        );
    });

    return (
        <div className={s.colorsBlock}>
            {elements}
            {colors.length > colorsLimit && (
                <button
                    aria-label="More colors"
                    className={s.plusCircleButton}
                    onClick={() => onPlusClickHandler && onPlusClickHandler()}
                    type="button"
                >
                    <div className={s.iconWrapper}>
                        <Icon icon={Plus} />
                    </div>
                </button>
            )}
        </div>
    );
};
